import { Button } from '@eleveo/components-react';
import React, { useEffect, useState } from 'react';
import { FormProps } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { EditAgentFormBody } from './EditAgentFormBody';
import { EDIT_AGENT_SUBMIT_BUTTON_TAG } from './constants';
import { SidebarContent, SidebarPanel, SidebarPart } from '../../components/LayoutNext/LayoutNext';
import { SidebarForm } from '../../components/LayoutNext/SidebarForm';
import { Agent, Queue, ShiftTemplate, Skill } from '../../graphql/components';
import { fullNameOfAgent } from '../../utils/helpers';

import type { AgentValues } from './types';

type AgentSidebarProps = {
  agent: Agent;
  handleCancel: () => void;
  handleSubmit: FormProps<AgentValues>['onSubmit'];
  queues: Queue[];
  shiftTemplates: ShiftTemplate[];
  skills: Skill[];
};

const initialAgent: AgentValues = {
  id: '',
  fullName: '',
  queueIds: [],
  shiftTemplateIds: [],
  skillIds: [],
};

const normalizeAgent = (agent: Agent) => ({
  id: agent.id,
  fullName: fullNameOfAgent(agent),
  queueIds: agent.queueIds,
  shiftTemplateIds: agent.shiftTemplateIds,
  skillIds: agent.skillIds,
});

export const AgentSidebar: React.FC<AgentSidebarProps> = ({
  agent,
  handleCancel,
  handleSubmit,
  queues,
  shiftTemplates,
  skills,
}) => {
  const { t } = useTranslation();

  const [initialValues, setInitialValues] = useState<AgentValues>(initialAgent);

  useEffect(() => {
    if (agent) {
      setInitialValues(normalizeAgent(agent));
    }
  }, [agent]);

  return (
    <SidebarForm<AgentValues>
      initialValues={initialValues}
      name="person-form"
      onClose={handleCancel}
      onSubmit={handleSubmit}
      title={t('person.editPerson')}
    >
      {({ form, invalid, pristine }) => (
        <>
          <SidebarPanel>
            <Button
              isDisabled={pristine || invalid}
              color="success"
              type="submit"
              testId={EDIT_AGENT_SUBMIT_BUTTON_TAG}
            >
              {t('layout.action.save')}
            </Button>
          </SidebarPanel>
          <SidebarContent>
            <SidebarPart>
              <EditAgentFormBody queues={queues} form={form} shiftTemplates={shiftTemplates} skills={skills} t={t} />
            </SidebarPart>
          </SidebarContent>
        </>
      )}
    </SidebarForm>
  );
};
